import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { format } from 'date-fns';

import { unescapeHtml } from '@ecp/common/src/utils/htmlUtil';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Popup from '@ecp/common/src/components/modal/bo/Popup';

import { yyyyMMddHHmmssToOtherFormat } from '@bo-utils/dateUtils';
import { getNotification } from '@bo-apis/customerService/notificationApi';
import { getPoNotificationDetail } from '@bo-apis/po/customerService/poNotificationApi';
import FormField from '@bo-components/common/form/FormField';
import Form from '@bo-components/common/form/Form';

const NoticePopup = ({ open, onClose, noticeSeq, isBO }) => {
  const [form, setForm] = useState({});

  useEffect(() => {
    if (open) {
      isBO
        ? getNotification(noticeSeq).then(({ result }) => setForm(result))
        : getPoNotificationDetail(noticeSeq).then(({ result }) => setForm(result));
    }
  }, [open, noticeSeq, isBO]);

  const fromDate = useMemo(() => {
    if (!form.fromDateTime) return '';

    return isBO
      ? format(new Date(form.fromDateTime), 'yyyy-MM-dd HH:mm')
      : yyyyMMddHHmmssToOtherFormat(form.fromDateTime, 'yyyy-MM-dd HH:mm');
  }, [form.fromDateTime, isBO]);

  const handleClose = () => {
    setForm({});
    onClose();
  };

  return (
    <Popup
      type={'Large'}
      open={open}
      header={'공지사항'}
      onConfirmClick={handleClose}
      onClose={handleClose}
      onCancelClick={handleClose}
      confirmButtonText={'닫기'}
      useCancelButton={false}
    >
      <Form>
        <FormField label={'공지번호'}>
          <TextBox>{form.notificationSeq}</TextBox>
        </FormField>
        <FormField label={'등록일시'}>
          <TextBox>{fromDate}</TextBox>
        </FormField>
        <FormField label={'제목'} full>
          <TextBox>{form.title}</TextBox>
        </FormField>
        <FormField label={'내용'} full valueStyle={{ minHeight: '482px' }}>
          <div dangerouslySetInnerHTML={{ __html: unescapeHtml(form.content) }} />
        </FormField>
      </Form>
    </Popup>
  );
};

export default NoticePopup;

NoticePopup.propTypes = {
  open: PropTypes.bool,
  isBO: PropTypes.bool,
  onClose: PropTypes.func,
  noticeSeq: PropTypes.string,
};
